import styled from 'styled-components';

export const StyledCourseContainer = styled.div`
  min-height: 700px;
  margin-bottom: 92px;
  width: 1100px;
  @media (max-width: 800px) {
    width: auto;
    margin-bottom: 52px;
  }
`;
